jQuery(function($) {
    initMobileMenu();
    initFancyList();
    initProductSlider();
    initCategoriesSlider();
    initLocationOfferings();
    initCustomSmoothScroll();
    initATSlider();
    popupModals();
    childtermSubnav();
    
    function initMobileMenu() {
        $('.mobile-nav-menu .menu-item-has-children').append('<span class="submenu-toggle"></span>');
        $('.mobile-nav-hamburger').on('click', function () {
            $('body, html').toggleClass('body-is-mobile');
            $('.mobile-nav-background').toggleClass('is-mobile');
            $('.mobile-nav-hamburger').toggleClass('mobile-burger');
            $('.burger').toggleClass('burger-x');
            $('.mobile-nav-menu-links').toggleClass('mobile-links-visible');
            $('.mobile-nav-container').toggleClass('mobile-nav-toggled');
            $('.mobile-topbar-links').toggleClass('mobile-topbar-nav');
        });

        $('.mobile-nav-menu .menu-item-has-children > .submenu-toggle').on('click', function (e) {
            e.preventDefault();
            $('.mobile-nav-menu .menu-item-has-children').not($(this).parent()).removeClass('mobile-show-submenu');
            $(this).parent().toggleClass('mobile-show-submenu');
        });

        $('.mobile-topbar-links .menu-item-has-children > a').on('click', function (e) {
            e.preventDefault();
            $('.mobile-topbar-links .menu-item-has-children').not($(this).parent()).removeClass('mobile-show-sites-submenu');
            $(this).parent().toggleClass('mobile-show-sites-submenu');
        });
    }

    function initFancyList() {
        var $list = $('.fancy-list .fl-rich-text > ul > li');
    
        $list.click(function () {
          var $elm    = $(this);
          var $subnav = $elm.find('> ul');
    
          if ($subnav[0]) {
            $subnav.slideToggle();
            $elm.toggleClass('active');
          }
        });
    } 

    function initProductSlider() {
        var $mainSlider = $('.product-detail .gallery .main_gallery-slider');
        var $navSlider = $('.product-detail .gallery .nav_gallery-slider');

        $mainSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.nav_gallery-slider'
        });
        $navSlider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.main_gallery-slider',
            dots: false,
            arrows: true,
            centerMode: false,
            focusOnSelect: true,
            variableWidth: true
        });
    }

    function initCategoriesSlider() {
        var $slider = $('.categories-slider');

        $slider.slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            centerMode: false,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        swipeToSlide: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        swipeToSlide: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                        swipeToSlide: true
                    }
                }
            ]
        });
    }
    
    function initLocationOfferings() {
        $offeringContainer = $('.location-offering_container');
        $offeringContainerTrigger = $('.location-offering_card');
        $offeringInfoContainerClose = $('.location-offering_info-panel-close');
        $thisParent = '';

        // Trigger info panel
        $offeringContainerTrigger.click(function() {
            $offeringContainer.css("z-index", "1").removeClass("active");
            $thisParent = $(this).closest($offeringContainer);
            $thisParent.css("z-index", "2").addClass("active");
        });

        // Hide if clicked away from active container
        $(document).mouseup(function(event) {
            if ( $thisParent != '' ) {
                if ( !$thisParent.is(event.target) && $thisParent.has(event.target).length === 0) {
                    $thisParent.removeClass("active");
                }
            }
        });

        // Manual close button
        $offeringInfoContainerClose.click(function() {
            $offeringContainer.css("z-index", "1").removeClass("active");
        });
    }

    function initCustomSmoothScroll() {
        // Load smooth scroll for non Beaver Builder pages
        if ( !$("body").hasClass('fl-builder') ) {
            console.log("Non BB page, load custom smooth scroll");
            $('a[href*="#"]:not([href="#"])').click(function () {
                if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                    if (target.length) {
                        $('html, body').animate({
                            scrollTop: target.offset().top
                        }, 1000);
                        return false;
                    }
                }
            });            
        }
    }

    function initATSlider() {
        $atSliderParentContainer = $('.at-slider');
        $index = 0;
        
        // There could be multiple on single page
        $atSliderParentContainer.each(function() {
            $this = $(this);
            
            $atSlider = $this.find('.at-slider_container');
            $atSliderNav = $this.find('.at-slider_navigation');
            $atSliderStatus = $this.find('.at-slider_navigation-paging');
    
            // Set initial slide status
            $atSlider.on('init', function(event, slick) {
                if ( slick.slideCount > 1 ) {
                    $atSliderStatus.text('1 /' + slick.slideCount);
                }
            });
            // Update after change
            $atSlider.on('reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = currentSlide + 1;
                $(this).siblings().find('.at-slider_navigation-paging').text(i + '/' + slick.slideCount);
            });
            
            $atSlider.slick({
                appendArrows: $atSliderNav,
                slidesToShow: 1,
            });
        });
    }

    function popupModals() {
        $('.modal-video').magnificPopup({
            type: 'inline',
            preloader: false,
            modal: true
        });

        $('.download-form').magnificPopup({
            type: 'inline',
            preloader: false,
            modal: true
        });
    }

    function childtermSubnav() {
        if ( $('.childterm-subnav').length ) {
            var breakpoint = 1200;
            var maxshow = 4;
            var allowSticky = false;

            // Elements
            $window = $(window);
            $subnavParent = $('.childterm-subnav');
            $subnavContainer = $('.childterm-subnav_container');
            $subnavDropdownTrigger = $('.childterm-subnav_dropdown-title');
            // Properties
            $subnavParentHeight = $subnavParent.height();
            $subnavContainerPosition = $subnavContainer.offset().top + 20;

            // On load:
            $subnavParent.css('min-height', $subnavParentHeight);

            // Sticky Functionality
            // On scroll:
            if ( allowSticky ) {
                $window.scroll(function() {
                    if ( $window.scrollTop() > $subnavContainerPosition ) {
                        $subnavParent.addClass('childterm-subnav--stuck');
                    } else {
                        $subnavParent.removeClass('childterm-subnav--stuck');
                    }
                });
            }

            // Dropdown Functionality
            // On load
            if ( $window.width() < breakpoint ) {
                $subnavParent.addClass('childterm-subnav--dropdown');
            }
            
            // On resize, mimic debouncing for performance
            var resizeTimeout;
            $window.resize(function(e) {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(function() {
                    console.log('resizing');
                    if ($window.width() < breakpoint) {
                        $subnavParent.addClass('childterm-subnav--dropdown');
                    } else {
                        $subnavParent.removeClass('childterm-subnav--dropdown');
                        $subnavParent.removeClass('childterm-subnav--show-list');
                    }
                }, 250);
            });

            // Drop Menu Trigger
            $subnavDropdownTrigger.click( function() {
                $subnavParent.toggleClass('childterm-subnav--show-list');
            });
        }
    }
});
